<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="marrayServiceIndex"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> /<a href="javascript:void(0)"  @click="urlTo('applyIndex')"> 个人办事</a> /<span>{{rootName}}</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="policy_search_part">
            <div class="policy_search">
              <input name="" v-model="searchTitle" type="text" placeholder="请输入标题" style="width: 570px;font-size:14px;">
              <button  style="width: 77px;"  @click="search()"></button>
            </div>
            <p></p>
          </div>

          <div class="clear"></div>
          <div class="aaa" style="padding-top: 40px;">
            <template>
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane   v-for="(item,index)  in listDataType" :label="item.name" :name="item.type" :key="index+'a'">
                  <div class="policy_right2" >
                    <ul v-if="knowListData && knowListData.length>0">
                      <li  v-for="(item,index) in knowListData" :key="index" @click="seeShare('marrayDetail',{detail_id:item.id})" >
                        <a  href="javascript:void(0)">
                          <dt style="height: 90px"><h3><img src="../../static/images/policy_sign6.png"></h3><p>{{item.time}}</p></dt>
                          <dd style="height: 90px;padding-top: 10px;">
                            <div style="height: 24px;line-height: 20px;font-size: 12px;border-bottom: 1px solid #d7d6d6;"><span style="font-weight: 600;">发布单位：</span>{{item.data_author}}</div>
                            <h4 style="margin-top: 10px;">{{item.title}} </h4>
                            <div  style="width:100%;height:48px;    color: #888888;line-height:24px;font-size: 12px;overflow:hidden;text-overflow:ellipsis">{{item.remark}}</div>
                          </dd>
                        </a>
                      </li>
                    </ul>
                    <div class="clear"></div>

                  </div>


                  <div v-if="knowListData.length>0 && knowListData" style="text-align: center;padding-top: 30px" class="block">
                    <el-pagination
                      layout="prev, pager, next"
                      :total="knowListTotal" :page-size="pageSize" @current-change="pageChange" @prev-click="prevClick" @next-click="nextClieck">
                    </el-pagination>
                  </div>

                    <div v-else style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                      <div><img src="../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                      <div>暂无数据</div>
                    </div>

                </el-tab-pane>


              </el-tabs>
            </template>
          </div>

        </div>

      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
import headers from "../components/Headers";
import fixedDiv from "../components/FixedDiv";
import footers from "../components/Footer";
export default {
  name: "public-index",
  components:{
    headers,fixedDiv,footers
  },
  filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 10) {
        return value.slice(0,10) + '...'
      }
      return value
    }
  },

  data() {
    let _self=this;
    return {
      options:[],
      active: 'publicIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      searchTitle:'',
      pageNum:1,
      pageSize:6,
      knowListData:[],
      knowListTotal:0,
      listDataType:[],
      knowName:'',
      knowType:'',
      pageTotal:0,
      activeName: 'all',
      rootName:'婚姻家庭辅导1',
      icCode:'all',


    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
  // selectedRegion(nv){
  //   this.getDepartAreas(nv[nv.length-1],0);
  // }
  },
  created(){
    let id = this.$route.query.id;
    if (id!="" && id!=undefined){
      this.gotoDetail(id)
    }
    this.initType();
    this.getListByType(1);
  },
  methods: {
    gotoDetail(detail_id){
      this.$router.push({path:'PolicyDetail',query:{detail_id:detail_id}})
    },
     handleClick(tab, event) {
         this.knowType=tab.name
         this.knowName=tab.label
        this.icCode=tab.name;
         this.pageChange(1)

    },

    initType(){
      var t=this;
      const options={
        type:'knowledge'
      }
      this.$https.post("api/pu/getMarrayRoot.do",options,response=>{
          console.log("respo:",response)
        if (response.status === 200 && response.data.code===200) {
          if(response.data.data && response.data.data.childList && response.data.data.childList.length>0){
            t.rootName=response.data.data.firstRootName;
            t.listDataType=response.data.data.childList;
          }else {
            t.listDataType=[]
          }
        } else {
          // t.departOption =[];
        }
      })
    },
      prevClick(a){
          this.pageNum=this.pageNum-1;
          this.getListByType();
      },
      nextClieck(a){
          this.pageNum=this.pageNum+1;
          this.getListByType();
      },
      pageChange(a){
          this.pageNum=a
          this.getListByType();
      },
    search(){
        this.pageChange(1)
    },

    getListByType(){

      this.$https.post("api/pu/listMarrayList.do",{icCode:this.icCode,pageSize:this.pageSize,pageNum:this.pageNum,searchKey:this.searchTitle},response=>{
        if (response.status === 200 && response.data.code===200) {
          this.knowListData = response.data.data.list;
          this.knowListTotal = response.data.data.total;
        } else {

        }
      })
    },
    seeShare(url,d){
      let routeUrl = this.$router.resolve({
        path: "/"+url,
        query: d
      });
      window.open(routeUrl.href, '_blank');
    },
    getKnowContent(id){

      this.$router.push({path:'marrayDetail',query:{detail_id:id,name:this.knowName}})

     /* this.$https.post("api/policy/getKnowledgeDeta.do",{id},response=>{
        if (response.status === 200 && response.data.code===200) {

        } else {
        }
      })*/

    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    }
  }
}



</script>
<style>
  .publicity table td {
    padding: 0px 5px;
  }
  .policy_left2 .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: #3f76ea;
    color: white;
  }
  .aaa .el-tabs__item{
    padding: 0 20px;
    height: 60px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 60px;
    display: inline-block;
    list-style: none;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
    position: relative;
  }
  body .el-table th.gutter {
    display: table-cell !important;  /*解决el-table表格边框不对齐错行,引起的原因：渲染完el-table后，对其进行宽度、高度的计算重新渲染*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/MarrayServiceIndex.vue